import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',

    '& .MuiBadge-dot': {
      backgroundColor: ({ onlineStatus }) =>
        onlineStatus === 'online'
          ? '#2ABB88'
          : onlineStatus === 'away'
          ? theme.palette.away
          : '#E4ECF0',
      zIndex: '50'
    }
  },

  badge: {
    '& > span': {
      backgroundColor: ({ onlineStatus }) =>
        onlineStatus === 'online'
          ? theme.palette.variant.success
          : onlineStatus === 'away'
          ? theme.palette.away
          : '#C6C6C6',
      zIndex: '50'
    }
  },

  endPosition: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    marginBottom: '0.5rem'
  }
}))

export default useStyles
